import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpService } from '../services/http.service';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {

  constructor(private httpService:HttpService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        next: () => null,
        error: (error: HttpErrorResponse) => {
          if (!this.httpService.serverErrorDialog) {
            this.httpService.openServerErrorDialog(error.status);
          }
        },
      })
    );
  }
}